import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";

// 1. Kill the Service Worker cache to stop the "Node restricted" ghost text
if ("serviceWorker" in navigator) {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    for (const registration of registrations) {
      registration.unregister();
    }
  });
}

const rootElement = document.getElementById("root");

if (!rootElement) {
  throw new Error("Failed to find the root element. Ensure index.html has <div id='root'></div>");
}

// 2. Wrap in StrictMode for better debugging of the MFA/Auth flows
createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>
);

// 3. Optional: Add a version log to verify sync in browser console
console.log("Nexus Node: Protocol v0.1 synchronized.");